import Sidebar from "../Side/Sidebar";
import 'aos/dist/aos.css';
import AOS from 'aos';
import { useState, useEffect } from "react";
import Topbar from "../Side/Topbar";
import AddInvoiceForm from "../Invoice/AddInvoiceForm";
import AdminSidebar from "../Side/AdminSidebar";
import { useAuth } from "../Auth/AuthContext"; // Import useAuth

const Invoice = () => {
  const { authState } = useAuth(); // Get authState from AuthContext
  const role = authState.roles;
  const admin = role === "Admin";
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="flex">
      {/* Sidebar */}
      {admin ? <AdminSidebar /> : <Sidebar />}

      {/* Main Content */}
      <div className="flex-1 bg-gray-100">

        <div className="flex-1 flex flex-col">
          <Topbar />
          <main className="pt-[60px] px-4">
            <div className="mt-6">

              {/* Invoice Section */}
              <div className="bg-white shadow-lg rounded-lg p-6">
                <h2 className="text-xl font-semibold text-gray-900">Add Invoice</h2>
                <AddInvoiceForm />
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
